
export function setLocaleCookie(locale) {
  document.cookie = `locale=%22${locale}%22;path=/;samesite=None;secure=true`;
}
